module.exports = __webpack_public_path__ + "img/MGH-Yokohama-3-2440x1172.cafdc4b7.jpg";